import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { RefreshCw } from 'lucide-react';

interface RetryPromptProps {
  onRetry: () => void;
  starting: boolean;
}

/**
 * Shown when an attempt did not meet the bar and the courier still has an
 * attempt left. Deliberately neutral - it invites another try without exposing
 * the score.
 */
const RetryPrompt: React.FC<RetryPromptProps> = ({ onRetry, starting }) => {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="mx-auto max-w-xl rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-sm"
    >
      <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-[#FFCC00]/20">
        <RefreshCw size={32} className="text-[#bf0035]" />
      </div>
      <h2 className="text-xl font-bold text-gray-900">
        {t('portal.training.retry.title')}
      </h2>
      <p className="mt-3 text-sm leading-relaxed text-gray-600">
        {t('portal.training.retry.message')}
      </p>
      <button
        type="button"
        onClick={onRetry}
        disabled={starting}
        className="btn-primary mx-auto mt-6 inline-flex items-center justify-center gap-2 disabled:opacity-50"
      >
        <RefreshCw size={16} />
        {starting
          ? t('portal.training.retry.starting')
          : t('portal.training.retry.action')}
      </button>
    </motion.div>
  );
};

export default RetryPrompt;
